import Vue from "vue";

export async function sendLinkFnolViaSMS(params) {
    const response = await Vue.prototype.$http.post(
        `/send_link_fnol_via_sms`, params
    );

    return response.data
}